<template>
  <div>
    <FilterItems :datasIn="providers" @filtered="updateData"></FilterItems>

    <catalog-table
      :tableHeaders="providerHeaders"
      :tableData="providersData"
      :propsToSearch="providerSearchableProps"
      :actions="providerActions"
      :loading="loading"
      :page-size="25"
    >
      <template v-if="canAddProvider" slot="search-toolbar-actions">
        <md-button class="md-success" @click="addProvider">
          <span class="md-label">
            <md-icon class="material-icons">add</md-icon>
          </span>
          Agregar Proveedor
        </md-button>
      </template>
    </catalog-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FilterItems from "./filters";
import { CatalogTable } from "@/components/";
import catalogService from "@/services/catalog";

import mapPermissions from "@/plugins/accountPermissions/mapPermissions";

export default {
  name: "Providers",
  components: {
    CatalogTable,
    FilterItems,
  },
  computed: {
    ...mapPermissions("Provider", "provider"),
    ...mapGetters({
      userCan: "account/userCan",
    }),
    providerActions() {
      return [
        {
          icon: "edit",
          exe: this.editProvider,
          showIf: () => this.canChangeProvider,
        },
        {
          icon: "visibility",
          exe: this.viewProvider,
        },
        // {
        //   icon: "close",
        //   exe: this.deleteProvider,
        //   showIf: () => this.canDeleteProvider,
        // },
      ];
    },
  },
  data() {
    return {
      loading: null,
      status: [],
      providers: [],
      providersData: [],
      providerSearchableProps: ["provider_number", "name", "rfc"],
      providerHeaders: {
        provider_number: "No. de proveedor",
        name: "Nombre",
        commercial_name: "Razón social",
        rfc: "RFC",
      },
    };
  },
  mounted() {
    catalogService
      .fetch("common/status/provider")
      .then((res) => (this.status = res.map((s) => s.status)));
    /* catalogService.fetch('providers')
        .then(res => this.providers = res) */
    this.fetchSinister();
  },
  methods: {
    fetchSinister() {
      this.loading = true;
      return catalogService
        .fetch("providers")
        .then((res) => {
          this.providers = res;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    updateData(data) {
      this.providersData = data;
    },
    viewProvider(p) {
      this.$router.push(`/provider/${p.provider_number}/`);
    },
    editProvider(p) {
      const routeD = this.$router.resolve(
        `/provider/editar/${p.provider_number}/`
      );
      window.open(routeD.href, "_blank");
    },
    addProvider() {
      this.$router.push("/provider/wizard");
    },
  },
};
</script>

<style lang="css" scoped>
.bottom-right-corner {
  position: absolute !important;
  width: 55px !important;
  height: 55px !important;
  bottom: 70px !important;
  right: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Providers/index.vue